export const skuMenuKeys = {
  all: ['skuMenus'],
  menus: venueId => [...skuMenuKeys.all, 'menus', venueId],
  details: venueId => [...skuMenuKeys.all, 'details', venueId],
};
